1<template>
	<div class="container-fluid">
		<nav class="navbar navbar-dark bg-dark justify-content-between">
			<div class="source mx-3">Выставки. Рабочие клиенты</div>
			<div class="source mx-3">{{ this.$store.state.user.lastName }} {{ this.$store.state.user.name }}</div>
		</nav> 
		<div class="row mt-2">
			<v-select
				class="mb-1"
				placeholder="Выберите выставку"
				v-model="this.$store.state.source"
				label="name"
				:options="sources">
			</v-select>
			<v-select
				class="mb-1"
				placeholder="Выберите компанию"
				v-model="this.$store.state.client"
				:dropdown-should-open="dropdownShouldOpen"
				:loading="!clients.length"
				label="TITLE"
				:reduce1="client => client.ID"
				:clearSearchOnSelect="false"
				@option:selected="clientSelect"
				:options="clients">
				<template #no-options>
					Ничего не найдено
				</template>
				<template #selected-option-container="{ option, deselect, multiple, disabled }">
					<div class="selected ms-2"><span v-if="option.TITLE">Выбрана компания  {{ option.TITLE }}</span></div>
				</template>
			</v-select>
			<v-select
				v-if="clientSelected"
				placeholder="Выберите контакт"
				v-model="this.$store.state.contact"
				:loading="!contacts.length"
				label="search"
				:reduce1="contact => contact.ID"
				:clearSearchOnSelect="false"
				:options="contacts">
				<template #no-options>
					Ничего не найдено
				</template>
				<template #selected-option-container="{ option, deselect, multiple, disabled }">
					<div class="selected ms-2">Выбран контакт  {{ option.LAST_NAME }} {{ option.NAME }}</div>
				</template>
				<template #option="{ LAST_NAME, NAME }">
					{{ LAST_NAME }} {{ NAME }}
				</template>
			</v-select>
			<div class="col-12">
				<div class="row">
					<div class="col-12 col-md-6 mt-3">
						<Info :company="companyInfo" />
					</div>
					<div class="col-12 col-md-6 mt-3">
						<Comments :items="comments"/>
					</div>
				</div>
			</div>
			<div v-if="this.$store.state.source && contactSelected" class="col mt-3">
				<div class="mb-2">
					<label class="form-label">Резюме встречи</label>
					<textarea class="form-control" v-model="this.$store.state.resume" rows="5"></textarea>
				</div>
				<button class="btn btn-secondary" @click="addActivity">Добавить дело</button>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import Info from '@/components/Info.vue'
import Comments from '@/components/Comments.vue'

export default {
	name: 'ExpoB24',
	computed: {
		clients(){
			return this.$store.state.clients
		},
		sources(){
			return this.$store.state.sources
		},
		clientSelected(){
			return this.$store.state.client != null
		},
		contactSelected(){
			return this.$store.state.contact != null
		},
		contacts(){
			return this.$store.state.contacts
		},
		comments(){
			if(this.$store.state.companyInfo) return this.$store.state.companyInfo.comments
			return []
		},
		companyInfo(){
			let info = JSON.parse(JSON.stringify(this.$store.state.companyInfo))
			delete info.comments
			return info
		}
	},
	mounted: function(){
		this.$store.dispatch('getClients')
		this.$store.dispatch('getSources')
		let urlParams = new URLSearchParams(window.location.search)
		let userID = urlParams.get('userid')
		let userName = urlParams.get('username')
		let userLastName = urlParams.get('userlastname')
		this.$store.commit('setUser', {id:userID, name:userName, lastName: userLastName})
	},
	methods: {
		dropdownShouldOpen(VueSelect){
			return VueSelect.search.length > 1 && VueSelect.open
		},
		clientSelect(){
			this.$store.state.companyInfo = {}
			let that = this
			axios
			.get('https://expob24.9330077.ru/getB24Contacts.php?id='+this.$store.state.client.ID)
			.then(function (response) {
				if(response.data.result) response.data = []
				that.$store.commit('setContacts', response.data)
			})
			.then(function () {
				that.$store.dispatch('getCompanyInfo')
			})
		},
		addActivity(){
			let that = this
			axios
			.post('https://expob24.9330077.ru/addActivity.php', {user:this.$store.state.user,cc:{client:this.$store.state.client, contact:this.$store.state.contact}, expoName:this.$store.state.source.name, resume:this.$store.state.resume },{headers: {'Content-Type':'application/x-www-form-urlencoded'}})
			.then(function(response){
				that.clear()
			})
		},
		clear(){
			this.$store.state.resume = ""
			this.$store.state.client = null
			this.$store.state.contact = null
			this.$store.state.companyInfo = {}
		}
	},
	watch: {
		clientSelected(newValue){
			if(!newValue) this.clear()
		}
	},
	components: {Info, Comments}
}
</script>

<style>
	.source{
		color: wheat;
	}
	.selected{
		display: flex;
		align-self: end;
	}
</style>
